import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = ['consumer'] }) => {
  const { user, userProfile, loading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!isAuthenticated) {
        // User is not authenticated, redirect to login
        navigate('/login');
        return;
      }

      if (!userProfile?.role) {
        // User profile not loaded yet, wait
        return;
      }

      // Check if user role is allowed
      if (!allowedRoles?.includes(userProfile?.role)) {
        // User doesn't have permission, redirect based on role
        if (userProfile?.role === 'admin') {
          navigate('/admin-portal-dashboard');
        } else if (userProfile?.role === 'manager') {
          navigate('/event-manager-dashboard');
        } else {
          navigate('/home');
        }
        return;
      }
    }
  }, [isAuthenticated, userProfile, loading, allowedRoles, navigate]);

  // Show loading while checking auth
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Don't render children if not authenticated or authorized
  if (!isAuthenticated || !userProfile?.role || !allowedRoles?.includes(userProfile?.role)) {
    return null;
  }

  return children;
};

export default ProtectedRoute;